import request from "@/utils/request";
// 获取套餐
export const getProducs = () => request.get(`/products`);
// 创建订单
export const createOrder = (data) => request.post('/order/createOrder', data);
// 查询订单状态
export const getOrderStatus = (data) => request.get(`/order/getOrderStatus/${data}`);